export default __webpack_public_path__ + "static/media/purpleHelm.d503645f.svg";